
import { Component, namespace, Vue } from 'bits/vue'
import type { SearchResultDataCollectionMap } from 'bits/web_search'
import { SearchFilters } from 'bits/web_search'
import OzDivider, { OzDividerColorScheme } from 'library/v4/components/OzDivider.vue'
import OzTabs, { OzTabsAccessibilityRole, OzTabsPlacementMode } from 'library/v4/components/OzTabs.vue'
import OzTextButton, { OzTextButtonColorScheme } from 'library/v4/components/OzTextButton.vue'

@Component({
  components: {
    OzTextButton,
    OzTabs,
    OzDivider,
  },
})
export default class ContentPickerSearchModes extends Vue {
  OzTextButtonColorScheme = OzTextButtonColorScheme
  OzTabsAccessibilityRole = OzTabsAccessibilityRole
  OzTabsPlacementMode = OzTabsPlacementMode
  OzDividerColorScheme = OzDividerColorScheme

  searchTabs = [
    { key: SearchFilters.Images, text: this.__('Images') },
    { key: SearchFilters.Gif, text: this.__('GIF') },
    { key: SearchFilters.Videos, text: this.__('YouTube') },
    { key: SearchFilters.Audio, text: this.__('Spotify') },
    { key: SearchFilters.Web, text: this.__('Web') },
  ]

  @namespace('browser').Getter isPhone!: boolean
  @namespace('contentPicker').Action openSearch!: () => void
  @namespace('contentPicker').Action pickSearchFilter!: (payload: { filter: SearchFilters }) => void
  @namespace('contentPicker').Getter searchFilter!: SearchFilters
  @namespace('contentPicker').Getter searchQuery!: string
  @namespace('contentPicker').Getter currentSearchResultsMap!: SearchResultDataCollectionMap
  @namespace('contentPicker').Action search!: (payload?: { query?: string; url?: string }) => void

  isShook = false
  SearchFilters = SearchFilters

  shake(): void {
    this.isShook = false
    setTimeout(() => {
      this.isShook = true
    }, 1)
  }

  pickFilter(filter: SearchFilters): void {
    this.openSearch()
    this.pickSearchFilter({ filter })
    if (!this.searchQuery || this.searchQuery.trim() == '') {
      this.$emit('pick-without-search', filter)
      return
    }
    // Search immediately after clicking the filter
    // if the results are not populated yet.
    if (
      !this.currentSearchResultsMap ||
      !this.currentSearchResultsMap[this.searchFilter] ||
      this.currentSearchResultsMap[this.searchFilter].length == 0
    ) {
      this.search()
    }
  }
}
